import { isLocalUrl, validateWindowSize, observeAndReveal } from '../utils.js';

export default function cardWidget7() {
  const widgetName = 'cardWidget7';
  const widgetOpts = cardWidget7Opts;

  const isDesktopScreen = validateWindowSize(800);
  const showDescription = false;
  const wrapContainerClass = 'cardWidget7-container-wrapper';
  const $widget = $(`#${widgetName}`);

  $widget.wrap(
    `<div class="${wrapContainerClass}"><div class="inner-container reveal-up js-reveal"></div></div>`,
  );

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: isDesktopScreen ? [] : ['all'],
    showDescription: showDescription,
    moreButton: true,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    textOverImage: true,
    maxItemsVisible: 8,
    itemsPerPanel: 1,
    buyNowButton: false,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomCards(data.items, showDescription);
        animateOffset();
      } else {
        $(`.${wrapContainerClass}`).remove();
      }
    },
  });

  function createCustomCards(widgetData, showDescription) {
    $widget.find('.image-container').append('<div class="overlay"></div>');
    $widget.find('.card-content').remove();

    $widget.find('.card-widget-item').each(function (x) {
      const { Title, Description, URL } = widgetData[x];
      let urlAttribute = isLocalUrl(URL) ? '' : 'target="_blank"';

      const $cardItem = $(this);

      $cardItem.append(`
          <div class="card-content">
            <div class="widget-title-wrapper">
              <span class="widget-title">
                ${Title}</span>
              </div>
            <div class="hover-content">
              ${showDescription ? `<p class="widget-description">${Description}</p>` : ''}
              ${URL ? `<a href="${URL}" class="button" ${urlAttribute}>More</a>` : ''}
            </div>
          </div>`);

      if (isLocalUrl(URL)) {
        $cardItem.removeAttr('target');
      }

      URL ? $cardItem.addClass('only-url') : $cardItem.addClass('empty-card').removeAttr('href');
    });
  }

  function animateOffset() {
    const $revealItems = $('.js-reveal');

    if (!$revealItems.length) return;

    const setOffset = ($el) => {
      const height = $el.outerHeight();
      const offset = height / 2;

      $el.css('--reveal-offset', `${offset}px`);
    };

    $revealItems.each(function () {
      setOffset($(this));
    });

    observeAndReveal($revealItems, {
      threshold: 0.15,
      rootMargin: '0px 0px -10% 0px',
    });

    $(globalThis).on('resize', () => {
      $revealItems.each(function () {
        setOffset($(this));
      });
    });
  }
}
